import { Moon, Sun } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/theme/ThemeProvider';

/**
 * The real, visible theme toggle (CLAUDE.md §8).
 *
 * ⚠️ [amended LIGHT-DEFAULT] THE TOOLTIP NO LONGER CLAIMS TO FOLLOW THE SYSTEM. It read
 * "Following your system setting (light). Click to choose." for anybody who had never pressed
 * it — which is now false in every case, because light is the default and the OS is never
 * consulted. This control IS the only way the theme changes, so it states one thing.
 */
export const ThemeToggle = () => {
  const { mode, toggle } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-label={`Switch to ${mode === 'dark' ? 'light' : 'dark'} theme`}
      title={`Theme: ${mode}. Click to switch.`}
      data-testid="theme-toggle"
      // 20px, matching the rest of the utility bar's chrome. The explicit variant
      // selector is required: `buttonVariants` ends with `[&_svg]:size-4` at specificity
      // (0,1,1), and a bare `size-5` on the icon (0,1,0) loses to it silently.
      className="[&_svg]:size-5"
    >
      {mode === 'dark' ? <Moon aria-hidden /> : <Sun aria-hidden />}
    </Button>
  );
};
